(() => {
  let opener = null;
  let previousOverflow = '';
  let backdropPointerDown = false;

  const dialog = () => document.getElementById('EUWarrantyDialog');

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-eu-warranty-open]');
    const modal = dialog();
    if (!link || !modal || typeof modal.showModal !== 'function') return;
    event.preventDefault();
    if (modal.open) return;

    opener = link;
    const image = modal.querySelector('[data-eu-warranty-image]');
    if (!image.hasAttribute('src')) image.src = image.dataset.src;
    previousOverflow = document.body.style.overflow;
    modal.showModal();
    document.body.style.overflow = 'hidden';
  });

  const init = () => {
    const modal = dialog();
    if (!modal) return;

    modal.querySelector('[data-eu-warranty-close]').addEventListener('click', () => modal.close());
    modal.addEventListener('pointerdown', event => {
      backdropPointerDown = event.target === modal;
    });
    modal.addEventListener('click', event => {
      if (event.target === modal && backdropPointerDown) modal.close();
      backdropPointerDown = false;
    });
    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape') event.stopPropagation();
    });
    modal.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      if (opener?.isConnected) opener.focus({ preventScroll: true });
      opener = null;
    });
  };

  // Deferred execution sees the dialog even before unrelated app scripts finish.
  init();
})();
